
export const HeaderIcons = {
  OpensClicks: 'clicks'
}
